<li
  #navbarNotificationDropdown="ngbDropdown"
  ngbDropdown
  class="nav-item dropdown-notification mr-25"
>
  <a
    class="nav-link"
    (click)="loadStartNotifications()"
    ngbDropdownToggle
    id="navbarNotificationDropdown"
  >
    <i class="ficon fa fas fa-bell" data-feather="bell"></i>
    <span class="badge badge-pill badge-danger badge-up">{{
      unreadCount || 0
    }}</span>
  </a>

  <ul
    ngbDropdownMenu
    aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right"
  >
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
        <div class="badge badge-pill badge-light-primary">
          {{ unreadCount || 0 }} New
        </div>
      </div>
    </li>

    <li class="scrollable-container media-list">
      <ng-container *ngIf="notifications?.data; else noNotifications">
        <a
          class="d-flex"
          href="javascript:void(0)"
          *ngFor="let message of notifications.data"
        >
          <div class="media d-flex align-items-start">
            <div
              class="media-body"
              (click)="
                navigationService.navigateByNotification(message);
                dropdown.close()
              "
            >
              <small *ngIf="message.type | notificationType as typeLabel" class="badge badge-pill badge-light-primary mb-25">{{ typeLabel }}</small>
              <p class="media-heading" [innerHTML]="message.title"></p>
              <small class="notification-text">{{ message.message }}</small>
            </div>
          </div>
        </a>
      </ng-container>

      <ng-template #noNotifications>
        <div class="media d-flex align-items-center">
          <p class="font-weight-bold text-center w-100 mb-0">
            No notifications found.
          </p>
        </div>
      </ng-template>
    </li>

    <li class="dropdown-menu-footer">
      <button
        class="btn btn-light btn-lg text-success btn-block"
        (click)="handleNavigate()"
      >
        View All
      </button>
    </li>
  </ul>
</li>
